import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

import { ceilingsDiffer, getEffectiveIsolatedMax } from '@flipster/features/src/shared/leverage/isolated-cap';
import { snapshotSpecBunja } from '@flipster/features/src/shared/snapshot/state';
import { OrderMarginType } from '@flipster/utils/types/base';

import { marginTypeBunja, symbolBunja } from '../bunja/base';
import { formBunja } from '../bunja/form';

export const marginTypeSelectModalBunja = bunja(() => {
  const { symbol } = bunja.use(symbolBunja);
  const { marginTypeAtom } = bunja.use(marginTypeBunja);
  const { instrumentsKeyBySymbolAtom } = bunja.use(snapshotSpecBunja);
  const { leverageAtom } = bunja.use(formBunja);

  const selectedMarginTypeAtom = atomWithDefault<OrderMarginType>((get) => get(marginTypeAtom));

  const instrumentAtom = atom((get) => get(instrumentsKeyBySymbolAtom)?.[symbol]);

  const crossMaxAtom = atom((get) => get(instrumentAtom)?.maxLeverageHardLimit ?? 1);

  const effectiveIsolatedMaxAtom = atom((get) => {
    const instrument = get(instrumentAtom);
    return getEffectiveIsolatedMax(instrument?.maxLeverageHardLimit ?? 1, instrument?.maxInitLeverageIsolatedMargin);
  });

  const ceilingsDifferAtom = atom((get) => ceilingsDiffer(get(crossMaxAtom), get(effectiveIsolatedMaxAtom)));

  const crossMarginSupportedAtom = atom((get) => get(instrumentAtom)?.crossMarginSupported);

  /** Isolated selected and form leverage above isolated ceiling → show clamp notice. */
  const showLeverageChangeNoticeAtom = atom((get) => {
    if (get(selectedMarginTypeAtom) !== 'Isolated') return false;
    return get(leverageAtom) > get(effectiveIsolatedMaxAtom);
  });

  return {
    selectedMarginTypeAtom,
    leverageAtom,
    crossMaxAtom,
    effectiveIsolatedMaxAtom,
    ceilingsDifferAtom,
    crossMarginSupportedAtom,
    showLeverageChangeNoticeAtom,
  };
});

marginTypeSelectModalBunja.debugLabel = 'marginTypeSelectModalBunja';
